/* eslint react/jsx-no-bind:0 */
/* eslint react/prop-types:0 */
/* eslint-disable no-debugger */
import React from "react"
import { CallbackComponent } from "redux-oidc"
import { withRouter } from "react-router"
import loadingImage from "./images/star-fade.gif"
import userManager from "./userManager"

const CallbackPage = (props) => {
  const container = {
    height: '100%',
    width: '100%',
    position: 'relative'
  }
  const img = {
    maxHeight: '100%',
    maxWidth: '100%',
    width: 'auto',
    height: 'auto',
    position: 'absolute',
    top: '0',
    bottom: '0',
    left: '0',
    right: '0',
    margin: 'auto'
  }
  return (
    <CallbackComponent
      userManager={userManager}
      successCallback={
        e => {
          console.log('Success redirect', e)

          const ua = window.navigator.userAgent.toLowerCase();
          const old_ie = ua.indexOf('msie');
          const new_ie = ua.indexOf('trident/');
          if ((old_ie > -1) || (new_ie > -1)) {
            props.history.push("/oldbrowser");
          } else {
            props.history.push("/");
          }
        }
      }
      errorCallback={
        e => {
          console.log(e);
        }
      } >
      <div style={container}>
        <img src={loadingImage} style={img} />
      </div>
    </CallbackComponent>
  )
}

export default withRouter(CallbackPage)


// WEBPACK FOOTER //
// ./src/CallbackComponent.js